var RosterUploadProgressMeter = require("components/org/roster_upload/RosterUploadProgressMeter");
var RosterUploadButtons = require("components/org/roster_upload/RosterUploadButtons");
var Glyphicon = require("components/utility/icons/Glyphicon");
var StudentRoster = require("lib/data/StudentRoster");
var CurrentUser = require("lib/account/CurrentUser");
var GradeLevel = require("lib/academic/GradeLevel");

class RosterUploadClasses extends React.Component {
	constructor(props) {
		super();
		autobind(this);
		this.state = {
			editMode: false
		};
	}

	toggleEditMode(e) {
		$wr.nope(e)
		this.setState({ editMode: !this.state.editMode }, function() {
			$(window).trigger("resize");
		});
	}

	confirmChanges() {
		var mapValues = {};
		var $selects = $(this.refs.table).find("[data-classroom]");

		_.each($selects, function(select) {
			var origClassroom = $(select).data("classroom");
			var newVal = $(select).val();
			mapValues[origClassroom] = newVal;
		});

		var mappedRosterData = this.props.roster.
			mapColumnValues(StudentRoster.Columns.CLASSROOM, mapValues);

		this.props.updateRosterData(mappedRosterData, function() {
			this.setState({ editMode: false });
		}.bind(this));
	}

	// Takes a single string name and deduces title and names
	deduceNameData(name) {
		var nameData = {};

		// Handle "Last, First format"
		if (name.indexOf(",") != -1) {
			name = name.split(",").reverse().join(" ");
		}

		var names = _.compact(name.split(" "));
		nameData.lastName = names.pop() || "???";
		if (names.length > 0 && _.includes($wr.Constants.TITLES, names[0])) {
			nameData.title = names.shift();
		}

		nameData.firstName = names.length > 0 ? names.join(" ") : "???";
		return nameData;
	}

	hasKindergartenOrPreK(gradeLevels) {
		return _.includes(gradeLevels, "-1") || _.includes(gradeLevels, "0");
	}

	renderRosterStatus() {
		var gradeLevels = _.compact(this.props.roster.getColumn(StudentRoster.Columns.GRADE_LEVEL));
		if (this.hasKindergartenOrPreK(gradeLevels)) {
			return (
				<p>
					<Glyphicon icon="exclamation-sign" className="alertMark" />{" "}
					<em>
						You have Kindergarten or Pre-K classes in your roster.
						If you have AM/PM sections, please make sure that they're 
						listed separately in the table below. You may have to modify
						the teacher names in your original roster file to make sure
						that they are correctly separated.
					</em>
				</p>
			); 
		}
	}

	renderTableHeader() {
		if (CurrentUser.isSchoolAdmin()) {
			var extraCells = [
				(<th key="title">Title</th>),
				(<th key="firstName">First Name</th>),
				(<th key="lastName">Last Name</th>),
				(<th key="email">Email</th>),
			];
		}
		return (
			<tr>
				<th>Class Name</th>
				{ extraCells }
				<th>Grade</th>
				<th>Students</th>
			</tr>
		);
	}

	renderTableRows() {
		var classrooms = this.props.roster.getColumn(StudentRoster.Columns.CLASSROOM);
		classrooms = _.compact(classrooms).sort();

		return _.map(_.uniq(classrooms), function(classroom) {
			var classCount = _.select(classrooms, function(oClassroom) {
				return oClassroom == classroom;
			}).length;

			var sampleCell = (<td className="csvSampleText">{ classCount }</td>);
			var gradeLevels = this.props.roster.getClassroomGradeLevels(classroom);
			var gradeLevelText = $wr.toSentence(_.map(gradeLevels, function(gradeLevel) {
				return GradeLevel.getName(gradeLevel);
			}));
			if (this.hasKindergartenOrPreK(gradeLevels)) {
				var alertIcon = (<Glyphicon icon="exclamation-sign" className="alertMark" />);
			}

			var teacherEmail = this.props.roster.getClassroomTeacherEmail(classroom);

			if (this.state.editMode) {
				if (CurrentUser.isSchoolAdmin()) {
					if (teacherEmail) {
						var emailMessage = (
							<span>{ teacherEmail }</span>
						);

					} else {
						var emailMessage = (
							<em>Add email to roster file</em>
						);
					}

					var extraCells = [(
						<td colSpan={ 3 } key="name">
							<em>Edit class name to change teacher name</em>
						</td>
					),(
						<td key="email">{ emailMessage }</td>
					)];
				}

				var gradeLevels = this.props.roster.getClassroomGradeLevels(classroom);
				var gradeLevelText = $wr.toSentence(_.map(gradeLevels, function(gradeLevel) {
					return GradeLevel.getName(gradeLevel);
				}));
				if (this.hasKindergartenOrPreK(gradeLevels)) {
					var alertIcon = (<Glyphicon icon="exclamation-sign" className="alertMark" />);
				}

				return (
					<tr key={ classroom }>
						<td>
							<input type="text" data-classroom={ classroom }
								defaultValue={ classroom } className="form-control" />
						</td>
						{ extraCells }
						<td>{ alertIcon } { gradeLevelText }</td>
						{ sampleCell }
					</tr>
				);

			} else {
				if (CurrentUser.isSchoolAdmin()) {
					var nameData = this.deduceNameData(classroom);
					var extraCells = [
						(<td key="title">{ nameData.title }</td>),
						(<td key="firstName">{ nameData.firstName }</td>),
						(<td key="lastName">{ nameData.lastName }</td>),
						(<td key="email">{ teacherEmail }</td>)
					];
				}

				return (
					<tr key={ classroom }>
						<td>{ classroom }</td>
						{ extraCells }
						<td>{ alertIcon } { gradeLevelText }</td>
						{ sampleCell }
					</tr>
				);
			}
		}.bind(this));
	}

	render() {
		var classCount = _.uniq(this.props.roster.getColumn(StudentRoster.Columns.CLASSROOM)).length;
		return (
			<div className="uploadManager">
				<RosterUploadProgressMeter index={ 3 } />

				{ this.renderRosterStatus() }

				<p>
					Your roster has { classCount } { $wr.pluralize("class", classCount, "classes") }.
				</p>

				<RosterUploadButtons noun="Classrooms"
					editMode={ this.state.editMode }
					nextStage={ this.props.nextStage }
					toggleEditMode={ this.toggleEditMode }
					confirmChanges={ this.confirmChanges } />

					<table className="table table-striped table-bordered csvConfirmTable" ref="table">
						<tbody>
							{ this.renderTableHeader() }
							{ this.renderTableRows() }
						</tbody>
					</table>
			</div>
		)
	}
};

RosterUploadClasses.propTypes = StrictPropTypes({
	nextStage: PropTypes.func.isRequired,
	updateRosterData: PropTypes.func.isRequired,

	// Instance of StudentRoster.js
	roster: PropTypes.object.isRequired
});

module.exports = RosterUploadClasses;



// WEBPACK FOOTER //
// ./modules/components/org/roster_upload/RosterUploadClasses.js